<script>
    import {FormValidation} from "../../../shared/directives/formValidation";
    import {LoginAPI} from "../../../apis/LoginAPI";

    export default {
        name: "ChangePasswordModal",
        data() {
            return {
                isLoading: false,
                accountFormData: {}
            }
        },
        props: ['data'],
        mounted(){
                this.accountFormData = {...this.data};
        },
        methods: {

            async save() {
                let formValidation = new FormValidation('#change-password-form')
                if (!formValidation.runAllValidations()) {
                    this.loading = false;
                    return;
                }


                this.isLoading = true;

                let resp = await LoginAPI.updateUserInfo(this.accountFormData.first_name, this.accountFormData.last_name);
                if(resp.httpStatus !== 201){
                    this.$toasted.show(resp.errors[Object.keys(resp.errors)[0]], {
                        theme: "bubble",
                        position: "top-center",
                        duration: 2000,
                        className: 'falcon-toasted',
                    });
                    SFAnalytics.track('Account Edit');
                }
                else {
                    this.$emit('close');
                    this.$toasted.show("Account updated successfully.", {
                        theme: "outline",
                        position: "top-center",
                        duration: 2000,
                        className: 'falcon-toasted-success',
                    });

                }
                this.isLoading = false;
            }
        }
    }
</script>
<template>
    <fragment>
        <div class="modal-title">
            Edit Account Info
            <i class="modal-close-button" @click="$emit('close')"></i>
        </div>

        <div class="modal-body">
            <form id="change-password-form" action="" >

                <div class="columns">
                    <div class="column">
                        <div class="field">
                            <label class="label">First Name</label>
                            <div class="control">
                                <input class="input" vrules="required" v-model="accountFormData.first_name"
                                       type="text"
                                       placeholder="First Name">
                            </div>
                            <div class="help is-danger vrule" rule="required">
                                This field is required.
                            </div>
                        </div>

                    </div>
                    <div class="column">
                        <div class="field">
                            <label class="label">Last Name</label>
                            <div class="control">
                                <input class="input" vrules="required" v-model="accountFormData.last_name"
                                       type="text"
                                       placeholder="Last Name">
                            </div>
                            <div class="help is-danger vrule" rule="required">
                                This field is required.
                            </div>
                        </div>

                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <div class="field">
                            <label class="label">Email</label>
                            <div class="control">
                                <input class="input" vrules="required" v-model="accountFormData.email"
                                       type="text" placeholder="Email" disabled="">
                            </div>
                            <div class="help is-danger vrule" rule="required">
                                This field is required.
                            </div>
                        </div>

                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <div class="button float-right" @click.prevent="$emit('close')">
                            Cancel
                        </div>
                    </div>
                    <div class="column" style="text-align: right" @click.prevent="save()">
                            <div class="button float-right is-primary" :class="{'is-loading': isLoading}">
                                Save
                            </div>
                    </div>
                </div>
            </form>
        </div>
    </fragment>
</template>
<style scoped lang="scss">
    .modal-title{
        background-image: url(../../../images/icons/account.svg);
    }
</style>
